<div [class.opened]="mobileMenuOpen" class="mobile-menu user-select-none">
    <ul class="list-group">
        <li class="list-group-item">
            Menu <span (click)="mobileMenuOpen = !mobileMenuOpen" class="icon-close_white"></span>
        </li>
        <li (click)="goHome()" class="list-group-item">
            <div class="icon-home"></div>
            Home
        </li>
        @if (
            (Functionalities.CustomerProjectsParticipate | hasFunctionality) ||
            (Functionalities.CustomerProjectsManage | hasFunctionality) ||
            customer.customer_type === CustomerType.straatwerk
        ) {
            <li
                routerLink="/{{ Routenames.customers }}/{{ customer.id }}/{{ Routenames.projects }}{{
                    projectId ? '/' + projectId : ''
                }}"
                class="list-group-item">
                <div class="icon-home"></div>
                Projecten
            </li>
        }
        <li (click)="searchToggle()" class="list-group-item">
            <div class="icon-search"></div>
            Zoeken
        </li>
        <li (click)="measuring = true; mobileMenuOpen = false" class="list-group-item">
            <div class="icon-measure"></div>
            Oppervlakte meten
        </li>
        <li
            [routerLink]="['/', Routenames.settings, { via: Routenames.customers + '/' + customer.id }]"
            class="list-group-item">
            <div class="icon-settings"></div>
            Instellingen
        </li>
        <li (click)="reload(); mobileMenuOpen = false" class="list-group-item">
            <div class="icon-sync"></div>
            Kaart herladen
        </li>
        <li (click)="centerCountry(); mobileMenuOpen = false" class="list-group-item">
            <div class="icon-netherlands"></div>
            Nederland
        </li>
        <li (click)="toggleMapType(); mobileMenuOpen = false" class="list-group-item">
            <div [class.icon-map]="mapTypeId === 'roadmap'" [class.icon-satellite]="mapTypeId === 'hybrid'"></div>
            <span>{{ mapTypeId === 'roadmap' ? 'Kaartweergave' : 'Sattelietweergave' }}</span>
        </li>
    </ul>
</div>
<div class="navbar-mobile user-select-none">
    <i (click)="mobileMenuOpen = !mobileMenuOpen" class="fas fa-bars"></i> <span>{{ customer.name }}</span>
</div>
<div
    class="searchbar user-select-none"
    [class.bar-visible]="searchbarVisible"
    [class.filter-visible]="filterbarVisible">
    <div class="d-flex flex-column h-100">
        <div class="sticky-top bg-body border-bottom px-3 pt-3 pb-2">
            <mat-form-field class="w-100 mb-0">
                <input
                    [formControl]="addressAutocomplete"
                    (focus)="onSearchInputFocus()"
                    id="searchinput"
                    matInput
                    name="searchinput"
                    autocomplete="off"
                    placeholder="Zoeken..."
                    type="text" />

                @if (addressAutocomplete.value) {
                    <button (click)="addressAutocomplete.setValue('')" aria-label="Clear" mat-icon-button matSuffix>
                        <mat-icon class="icon-close">close</mat-icon>
                    </button>
                }
            </mat-form-field>
        </div>

        <div class="flex-grow-1" style="overflow-y: auto; overflow-x: hidden">
            <div class="list-items d-flex flex-column gap-2">
                @for (result of addressResults(); track result.id) {
                    <div class="item" role="button" (click)="goToAddress(result)">
                        <div class="row align-items-center">
                            <div class="col-6 text-center">
                                <div class="marker">
                                    <i class="fas fa-map-marker-alt"></i>
                                </div>
                            </div>
                            <div class="col-18 text-truncate">
                                {{ result.street }} {{ result.housenumber }} {{ result.place }}
                            </div>
                        </div>
                        <div class="arrow"></div>
                    </div>
                }

                @for (result of searchResults; track result.id) {
                    <div class="item" role="button" (click)="scrollToWorkarea(result.id)">
                        <div class="row align-items-center">
                            <div class="col-6 text-center">
                                <div
                                    class="marker"
                                    [innerHTML]="
                                        Settings.getMarker(result.id, result.number, result.status_colorcode) | safeHtml
                                    "></div>
                            </div>
                            <div class="col-16 text-truncate">
                                {{ result.street }} {{ result.housenumber }} {{ result.place }}
                            </div>
                        </div>
                        <div class="arrow"></div>
                    </div>
                }

                @for (result of hectoPins(); track result.id) {
                    <div (click)="goToHectometre(result)" class="item">
                        <div class="row">
                            <div class="col-6 marker">
                                <img [src]="(result | hectoPinIcon)?.url" class="marker" />
                            </div>
                            <div class="col-16 text txt-ellipsis">
                                {{ result.waynumber }} - {{ result.hectometre / 10 | number: '1.1-1' }}
                                @if (result.direction || result.letter; as suffix) {
                                    - {{ suffix }}
                                }
                            </div>
                        </div>
                        <div class="arrow"></div>
                    </div>
                }

                <div class="row">
                    @if (appliedAnyFilter) {
                        <div class="col-24 text-center">
                            Er zijn filters actief. Deze kunnen invloed hebben op de zoekresultaten.
                        </div>
                    }
                    @if (!loading && !searchResults.length && addressAutocomplete.value) {
                        <div class="col-24 text-center">Er zijn geen werkvakken gevonden</div>
                    }
                    <div class="col-24">
                        @if (loading) {
                            <app-processbar></app-processbar>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
@if (customer) {
    <div
        [class.bar-visible]="searchbarVisible"
        [class.filter-visible]="filterbarVisible"
        [class.filter-was-visible]="filterbarWasVisible"
        class="near-searchbar user-select-none">
        <div [className]="'pdf-style-' + pdfStyle + ' logo-small float-end'" routerLink="/"></div>
        <google-map
            #googleMap
            height="100%"
            width="100%"
            [mapTypeId]="mapTypeId"
            [options]="options"
            (mapClick)="workareaClick($event)"
            (contextmenu)="openContextMenu($event, contextMenu)">
            <map-polygon [paths]="customerRegion.points" [options]="polygonOptions"></map-polygon>
            @if (
                filteredWorkareas()?.length &&
                (screenshot ||
                    Settings.mapSettings['hide_clusters'] ||
                    actualZoom >= 16 ||
                    workareasInBoundsCount < doNotClusterBelowPointsInView)
            ) {
                @for (workarea of filteredWorkareas(); track workarea.id) {
                    <!-- Show polygon if workarea has geom_geojson, zoom is high enough and the polygon overlaps the map -->
                    @if (
                        workarea.geom_geojson &&
                        actualZoom >= 18 &&
                        (renderBounds | mapBoundsContains: (workarea.geom_geojson | geojsonBounds))
                    ) {
                        <map-polygon
                            [paths]="workarea.geom_geojson | geojsonToPaths"
                            [options]="workarea | workareaPolygonOptions">
                        </map-polygon>
                    }
                    @if (renderBounds | mapBoundsContains: (workarea | latLngPosition)) {
                        <!-- Always show marker (on top of polygon or standalone) -->
                        <map-marker
                            [position]="workarea | latLngPosition"
                            [options]="markerOptions"
                            [icon]="workarea | workareaMarker: filteredWorkareas()">
                        </map-marker>
                    }
                }
            }
            <!-- Kan de if statements niet bij elkaar voegen omdat anders de clusterWorkareas pipe wordt vernietigd en dan de cache niet meer bestaat -->
            @if (!screenshot && !Settings.mapSettings['hide_clusters'] && filteredWorkareas()?.length) {
                @for (cluster of filteredWorkareas() | clusterWorkareas: actualZoom : status; track $index) {
                    @if (actualZoom < 16 && workareasInBoundsCount >= doNotClusterBelowPointsInView) {
                        <map-polygon [paths]="cluster.paths" [options]="cluster.options"></map-polygon>
                    }
                }
            }
            @for (hectometer of hectometers; track hectometer.id) {
                @if (renderBounds | mapBoundsContains: (hectometer | latLngPosition)) {
                    <map-marker
                        [position]="hectometer | latLngPosition"
                        [options]="markerOptions"
                        [icon]="hectometer | hectoPinIcon">
                    </map-marker>
                    @if (hectometer.poles) {
                        @for (pole of hectometer.poles; track pole.id) {
                            @if (renderBounds | mapBoundsContains: (pole | latLngPosition)) {
                                <map-marker
                                    [position]="pole | latLngPosition"
                                    [options]="markerOptions"
                                    [icon]="pole | hectoPinIcon">
                                </map-marker>
                            }
                        }
                    }
                }
            }
            @if (gpsLocation) {
                <map-marker [icon]="'gps' | mapMarker" [position]="gpsLocation"></map-marker>
            }
        </google-map>
        <app-map-measurements
            [measuring]="measuring"
            [selectablePoints]="filteredWorkareas()"
            [googleMap]="googleMap"
            [projectId]="projectId"
            (selectedPointsChange)="onMeasurementSelectionChange($event)"
            (openExportDialog)="openMeasurementExportDialog()"
            (openTransferDialog)="openMeasurementTransferDialog()"
            (measuringChange)="measuring = $event"></app-map-measurements>
        @if (!screenshot) {
            <div class="sidebar left d-none d-md-block user-select-none">
                <div (click)="searchToggle()" class="sidebar-icon search"></div>
                <div (click)="goHome()" class="sidebar-icon home"></div>
                @if (projectOverviewAccess | hasFunctionality) {
                    <div
                        class="sidebar-icon add-doc"
                        routerLink="/{{ Routenames.customers }}/{{ customer.id }}/{{ Routenames.projects }}{{
                            projectId ? '/' + projectId : ''
                        }}"></div>
                } @else {
                    <div
                        class="sidebar-icon add-doc"
                        routerLink="/{{ Routenames.customers }}/{{ customer.id }}/{{ Routenames.projects }}"></div>
                }
                <div (click)="reload()" class="sidebar-icon sync"></div>
                <div
                    [routerLink]="['/', Routenames.settings, { via: Routenames.customers + '/' + customer.id }]"
                    class="sidebar-icon settings"
                    queryParamsHandling="merge"></div>
                <div (click)="centerGps()" class="sidebar-icon sdb-target"></div>
                @if (Features.WorkareasSave | hasFeature) {
                    <div (click)="createWorkarea()" class="sidebar-icon add"></div>
                }
            </div>
            <div class="sidebar right d-none d-md-block user-select-none">
                <div (click)="filterToggle()" class="sidebar-icon search">
                    <div [class.filtered]="totalWorkareaCount - filteredWorkareaCount > 0" class="dot"></div>
                </div>
                <div
                    (click)="measuring = true"
                    class="sidebar-icon measure-area"
                    [class.active]="measuring"
                    title="Oppervlakte meten">
                    <i class="fal fa-vector-square"></i>
                </div>
                <div (click)="centerCountry()" class="sidebar-icon netherlands"></div>
                <div (click)="centerCustomer()" class="sidebar-icon customer"></div>
                <div
                    (mousedown)="headingStart()"
                    (mouseup)="headingStop()"
                    (touchstart)="headingStart()"
                    (touchend)="headingStop()"
                    (click)="headingSingle()"
                    class="sidebar-icon">
                    <i class="fal fa-rotate-right"></i>
                </div>
                <div
                    (click)="toggleMapType()"
                    [class.map]="mapTypeId === 'roadmap'"
                    [class.satellite]="mapTypeId === 'hybrid'"
                    class="sidebar-icon earth"></div>
            </div>
            @if (!movingWorkarea) {
                <div class="sidebar bottom d-bock d-md-none user-select-none">
                    <div class="row">
                        <div class="col">
                            <div class="sidebar-icon home" routerLink="/"></div>
                        </div>
                        <div class="col">
                            <div class="sidebar-icon search" (click)="filterToggle()">
                                <div
                                    [class.filtered]="totalWorkareaCount - filteredWorkareaCount > 0"
                                    class="dot"></div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="sidebar-icon" [matMenuTriggerFor]="menu">
                                <i class="fa fa-bars"></i>
                            </div>
                            <mat-menu #menu="matMenu" xPosition="before" cdkover>
                                <button
                                    mat-menu-item
                                    (mousedown)="headingStart()"
                                    (mouseup)="headingStop()"
                                    (touchstart)="headingStart()"
                                    (touchend)="headingStop()"
                                    (click)="headingSingle()">
                                    <i class="far me-2 fa-rotate-right"></i>
                                    <span>Draai kaart</span>
                                </button>
                                <button
                                    mat-menu-item
                                    [routerLink]="[
                                        '/',
                                        Routenames.settings,
                                        { via: Routenames.customers + '/' + customer.id },
                                    ]"
                                    class="list-group-item">
                                    <i class="far me-2 fa-gear"></i>
                                    <span>Instellingen</span>
                                </button>
                                <button mat-menu-item (click)="centerCountry()">
                                    <i class="far me-2 fa-map"></i>
                                    <span>Centreer Nederland</span>
                                </button>
                                <button mat-menu-item (click)="centerCustomer()">
                                    <i class="far me-2 fa-map"></i>
                                    <span>Centreer klantgebied</span>
                                </button>
                                <button mat-menu-item (click)="measuring = true" class="list-group-item">
                                    <i class="far me-2 fa-draw-square"></i>
                                    Oppervlakte meten
                                </button>
                                <button mat-menu-item (click)="copyGoogleMapsLink()">
                                    <i class="far me-2 fa-link"></i>
                                    Link kopiëren
                                </button>
                            </mat-menu>
                        </div>
                        <div class="col">
                            <div (click)="centerGps()" class="sidebar-icon sdb-target"></div>
                        </div>
                        <div class="col">
                            @if (Features.WorkareasSave | hasFeature) {
                                <div (click)="createWorkarea()" class="sidebar-icon add"></div>
                            }
                        </div>
                    </div>
                </div>
            }
            <div class="target"></div>
        }
        <div
            [style.bottom]="selectedPosition.bottom"
            [style.left]="selectedPosition.left"
            [style.max-height]="selectedPosition.maxHeight"
            [style.right]="selectedPosition.right"
            [style.top]="selectedPosition.top"
            class="selected-workareas user-select-none">
            @for (workarea of selectedWorkareas; track workarea) {
                <a
                    class="workarea"
                    routerLink="/{{ Routenames.customers }}/{{ customer.id }}/{{ Routenames.workareas }}/{{
                        workarea.id
                    }}{{ workarea.has_documents ? '/' + Routenames.documents : null }}">
                    <div class="details">
                        <div class="number">
                            {{ workarea.has_documents ? workarea.street : workarea.number }}
                            <i class="icon-more-custom pointer"></i>
                        </div>
                        <table border="0" cellpadding="0" cellspacing="0">
                            <tr>
                                <td class="txtbold">Soort</td>
                                <td width="10"></td>
                                @if (workarea.extra && workarea.extra.vogzang_type) {
                                    <td>
                                        {{ workarea.extra.vogzang_type }}
                                        @if (workarea.extra && workarea.extra.vogzang_service) {
                                            <small> ({{ workarea.extra.vogzang_service }}) </small>
                                        }
                                    </td>
                                }
                                @if (workarea.extra && workarea.extra.damage) {
                                    <td>
                                        {{ workarea.extra.damage }}
                                    </td>
                                }
                                @if (workarea.has_documents) {
                                    <td>Werklocatie</td>
                                }
                            </tr>
                            <tr>
                                <td class="txtbold">Status</td>
                                <td width="10"></td>
                                <td>{{ workarea.status_name }}</td>
                            </tr>
                        </table>
                    </div>
                    @if (!workarea.has_documents) {
                        <div style.background-image="url('{{ workarea.image }}?tinythumb=true')" class="image"></div>
                    }
                </a>
            }
        </div>
    </div>
}
<div
    [class.bar-visible]="searchbarVisible"
    [class.filter-visible]="filterbarVisible"
    class="filterbar user-select-none">
    <app-workareas-filter #mapFilter [customer]="customer" [workareas]="workareas()"></app-workareas-filter>

    <div class="col-24">
        <b>Dit filter toont {{ filteredWorkareaCount }} van {{ totalWorkareaCount }} werkvakken.</b>
        <br /><br />
        <i>
            Afgebroken, uitgevoerde en goedgekeurde werkvakken worden alleen getoond als dit is ingesteld in de
            instellingen.
        </i>
        <br /><br />
    </div>
</div>
@if (movingWorkarea) {
    <div class="buttons-move-pushpin">
        <div class="mb-3">
            <button (click)="moveWorkarea()" class="btn btn-success w-100 z-depth-0">Nieuwe locatie bevestigen</button>
        </div>
    </div>
}
<ng-template #contextMenu>
    <div cdkMenu class="context-menu">
        <button cdkMenuItem class="menu-item" (click)="copyGoogleMapsLink()">Link kopiëren</button>
    </div>
</ng-template>
